import actions from 'actions/tasks'
import { createChildFormViewContainer } from 'factories/ChildFormView'
import { tasksFormViewExtraDispatchToProps } from 'helpers/tasks'
import Component from 'components/Assets/Tasks/FormView'

export default createChildFormViewContainer({
  actions,
  extraDispatchToProps: tasksFormViewExtraDispatchToProps,
})(Component)
